import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetQuestionDetailsRPC } from "./getQuestionDetailsRPC";

export class GetQuestionDetailsRPCClientImpl extends GetQuestionDetailsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetQuestionDetailsRPC.Request): Promise<LeoRPCResult<GetQuestionDetailsRPC.Response, GetQuestionDetailsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey/GetQuestionDetails",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetQuestionDetailsRPC.ResponseDTO,
      GetQuestionDetailsRPC.Errors.ErrorsDTO,
      GetQuestionDetailsRPC.Response,
      GetQuestionDetailsRPC.Errors.Errors
    >(
      response,
      "survey/GetQuestionDetails",
      GetQuestionDetailsRPC.Response.fromDTO,
      GetQuestionDetailsRPC.Errors.fromDTO
    );
  }
}
